const ProvinsiData = [
    {
        "name": "Aceh (NAD)",
        "code": "11",
        "iso": "AC",
        "capital": "Banda Aceh",
        "governor": "",
        "is_active": 1,
        "created_at": null,
        "updated_at": null
    },
    {
        "name": "Sumatera Utara",
        "code": "12",
        "iso": "SU",
        "capital": "Medan",
        "governor": "",
        "is_active": 1,
        "created_at": null,
        "updated_at": null
    },
    {
        "name": "Sumatera Barat",
        "code": "13",
        "iso": "SB",
        "capital": "Padang",
        "governor": "",
        "is_active": 1,
        "created_at": null,
        "updated_at": null
    },
    {
        "name": "Riau",
        "code": "14",
        "iso": "RI",
        "capital": "Pekanbaru",
        "governor": "",
        "is_active": 1,
        "created_at": null,
        "updated_at": null
    },
    {
        "name": "Jambi",
        "code": "15",
        "iso": "JA",
        "capital": "Jambi",
        "governor": "",
        "is_active": 1,
        "created_at": null,
        "updated_at": null
    },
    {
        "name": "Sumatera Selatan",
        "code": "16",
        "iso": "SS",
        "capital": "Palembang",
        "governor": "",
        "is_active": 1,
        "created_at": null,
        "updated_at": null
    },
    {
        "name": "Bengkulu",
        "code": "17",
        "iso": "BE",
        "capital": "Bengkulu",
        "governor": "",
        "is_active": 1,
        "created_at": null,
        "updated_at": null
    },
    {
        "name": "Lampung",
        "code": "18",
        "iso": "LA",
        "capital": "Bandar Lampung",
        "governor": "",
        "is_active": 1,
        "created_at": null,
        "updated_at": null
    },
    {
        "name": "Kepulauan Bangka Belitung",
        "code": "19",
        "iso": "BB",
        "capital": "Pangkalpinang",
        "governor": "",
        "is_active": 1,
        "created_at": null,
        "updated_at": null
    },
    {
        "name": "Kepulauan Riau",
        "code": "21",
        "iso": "KR",
        "capital": "Tanjung Pinang",
        "governor": "",
        "is_active": 1,
        "created_at": null,
        "updated_at": null
    },
    {
        "name": "DKI Jakarta",
        "code": "31",
        "iso": "JK",
        "capital": "Jakarta",
        "governor": "",
        "is_active": 1,
        "created_at": null,
        "updated_at": null
    },
    {
        "name": "Jawa Barat",
        "code": "32",
        "iso": "JB",
        "capital": "Bandung",
        "governor": "",
        "is_active": 1,
        "created_at": null,
        "updated_at": null
    },
    {
        "name": "Jawa Tengah",
        "code": "33",
        "iso": "JT",
        "capital": "Semarang",
        "governor": "",
        "is_active": 1,
        "created_at": null,
        "updated_at": null
    },
    {
        "name": "DI Yogyakarta",
        "code": "34",
        "iso": "YO",
        "capital": "Yogyakarta",
        "governor": "",
        "is_active": 1,
        "created_at": null,
        "updated_at": null
    },
    {
        "name": "Jawa Timur",
        "code": "35",
        "iso": "JI",
        "capital": "Surabaya",
        "governor": "",
        "is_active": 1,
        "created_at": null,
        "updated_at": null
    },
    {
        "name": "Banten",
        "code": "36",
        "iso": "BT",
        "capital": "Serang",
        "governor": "",
        "is_active": 1,
        "created_at": null,
        "updated_at": null
    },
    {
        "name": "Bali",
        "code": "51",
        "iso": "BA",
        "capital": "Bali",
        "governor": "",
        "is_active": 1,
        "created_at": null,
        "updated_at": null
    },
    {
        "name": "Nusa Tenggara Barat (NTB)",
        "code": "52",
        "iso": "NB",
        "capital": "Mataram",
        "governor": "",
        "is_active": 1,
        "created_at": null,
        "updated_at": null
    },
    {
        "name": "Nusa Tenggara Timur (NTT)",
        "code": "53",
        "iso": "NT",
        "capital": "Kupang",
        "governor": "",
        "is_active": 1,
        "created_at": null,
        "updated_at": null
    },
    {
        "name": "Kalimantan Barat",
        "code": "61",
        "iso": "KB",
        "capital": "Pontianak",
        "governor": "",
        "is_active": 1,
        "created_at": null,
        "updated_at": null
    },
    {
        "name": "Kalimantan Tengah",
        "code": "62",
        "iso": "KT",
        "capital": "Palangkaraya",
        "governor": "",
        "is_active": 1,
        "created_at": null,
        "updated_at": null
    },
    {
        "name": "Kalimantan Selatan",
        "code": "63",
        "iso": "KS",
        "capital": "Banjarmasin",
        "governor": "",
        "is_active": 1,
        "created_at": null,
        "updated_at": null
    },
    {
        "name": "Kalimantan Timur",
        "code": "64",
        "iso": "KI",
        "capital": "Samarinda",
        "governor": "",
        "is_active": 1,
        "created_at": null,
        "updated_at": null
    },
    {
        "name": "Kalimantan Utara",
        "code": "65",
        "iso": "KU",
        "capital": "Tanjungselor",
        "governor": "",
        "is_active": 1,
        "created_at": null,
        "updated_at": null
    },
    {
        "name": "Sulawesi Utara",
        "code": "71",
        "iso": "SA",
        "capital": "Manado",
        "governor": "",
        "is_active": 1,
        "created_at": null,
        "updated_at": null
    },
    {
        "name": "Sulawesi Tengah",
        "code": "72",
        "iso": "ST",
        "capital": "Palu",
        "governor": "",
        "is_active": 1,
        "created_at": null,
        "updated_at": null
    },
    {
        "name": "Sulawesi Selatan",
        "code": "73",
        "iso": "SN",
        "capital": "Makassar",
        "governor": "",
        "is_active": 1,
        "created_at": null,
        "updated_at": null
    },
    {
        "name": "Sulawesi Tenggara",
        "code": "74",
        "iso": "SG",
        "capital": "Kendari",
        "governor": "",
        "is_active": 1,
        "created_at": null,
        "updated_at": null
    },
    {
        "name": "Gorontalo",
        "code": "75",
        "iso": "GO",
        "capital": "Gorontalo",
        "governor": "",
        "is_active": 1,
        "created_at": null,
        "updated_at": null
    },
    {
        "name": "Sulawesi Barat",
        "code": "76",
        "iso": "SR",
        "capital": "Mamuju",
        "governor": "",
        "is_active": 1,
        "created_at": null,
        "updated_at": null
    },
    {
        "name": "Maluku",
        "code": "81",
        "iso": "MA",
        "capital": "Ambon",
        "governor": "",
        "is_active": 1,
        "created_at": null,
        "updated_at": null
    },
    {
        "name": "Maluku Utara",
        "code": "82",
        "iso": "MU",
        "capital": "Sofifi",
        "governor": "",
        "is_active": 1,
        "created_at": null,
        "updated_at": null
    },
    {
        "name": "Papua",
        "code": "91",
        "iso": "PA",
        "capital": "Jayapura",
        "governor": "",
        "is_active": 1,
        "created_at": null,
        "updated_at": null
    },
    {
        "name": "Papua Barat",
        "code": "92",
        "iso": "PB",
        "capital": "Manokwari",
        "governor": "",
        "is_active": 1,
        "created_at": null,
        "updated_at": null
    }
]

export default ProvinsiData